export const kr = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
};

export const dato = (s) => {
  if (!s) return '';
  try {
    return new Date(s).toLocaleDateString('nb-NO');
  } catch { return s; }
};

export const idag = () => new Date().toISOString().slice(0, 10);
export const omDager = (d) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + d);
  return dt.toISOString().slice(0, 10);
};
